<ng-container *ngIf="selectedContactComponent; else notSelectedContact">
  <ng-container *ngIf="this.selected">
    <ng-container [ngTemplateOutlet]="showSelectedCondition"> </ng-container>
  </ng-container>
</ng-container>
<ng-template #notSelectedContact>
  <ng-container [ngTemplateOutlet]="showSelectedCondition"> </ng-container>
</ng-template>

<ng-template #showSelectedCondition>
  <div class="report-cardlist">
    <div class="user-list" (click)="onClick()">
      <ng-container *ngIf="selectedContactComponent; else notSelectedContact">
        <ng-container [ngTemplateOutlet]="userInitialsTemplate"> </ng-container>
      </ng-container>
      <ng-template #notSelectedContact>
        <div class="initials-container initials-border">
          <span class="privacy-icon" *ngIf="selected; else showInitials">
            <mat-icon svgIcon="done-icon" aria-hidden="false"></mat-icon>
          </span>
        </div>
        <ng-template #showInitials>
          <ng-container [ngTemplateOutlet]="userInitialsTemplate"> </ng-container>
        </ng-template>
      </ng-template>
      <div class="userInfo">
        <div class="username">{{ user?.firstName || '-' }} {{ user?.lastName || '-' }}</div>
        <div *ngIf="isOnMIQ != null" class="contactcard-icon">
          <label *ngIf="isOnMIQ" class="miq-icon" l10nTranslate>shared.miq</label>
          <mat-icon *ngIf="!isOnMIQ">cloud_queue</mat-icon>
        </div>
        <div class="email">{{ user?.emailAddress || '-' }}</div>
      </div>
      <div
        class="assign-bgcolor"
        *ngIf="selectedContactComponent && isUserAllowed"
        (click)="removeContact()"
        miqStopClick
      >
        <mat-icon>close</mat-icon>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #userInitialsTemplate>
  <div class="initials-container" [ngStyle]="{ 'background-color': color }">
    <span>{{ (user?.firstName || '-')[0] | uppercase }}{{ (user?.lastName || '-')[0] | uppercase }}</span>
  </div>
</ng-template>
